import { render } from "./FormatMessage.vue?vue&type=template&id=4f3bef05&scoped=true"
import script from "./FormatMessage.vue?vue&type=script&lang=js"
export * from "./FormatMessage.vue?vue&type=script&lang=js"

import "./FormatMessage.vue?vue&type=style&index=0&id=4f3bef05&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f3bef05"]])

export default __exports__